import { z } from 'zod';

export enum FeatureFlag {
  PUBLIC = 'public',
  INTERNAL = 'internal',
  DISABLED = 'disabled',
}

export const FeatureFlagSchema = z.nativeEnum(FeatureFlag);
